import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20840 20854"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:230.945}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M3458 19165h11668l227 5h2030l-1-6940c0-69 0-137 6-206 33-397 344-702 762-716 402 0 736 294 782 693 7 67 7 132 6 199v8538H1904l-1-8987c0-54-1-108 3-161 29-413 357-740 788-740 413 10 732 328 760 737 5 67 4 133 4 200v7378z"
        className="fil0 "
      />
      <path
        d="m10817 545 4 4c3196 3057 6392 6114 9583 9167l25 24c49 46 95 92 137 145 234 308 208 731-68 1003-142 140-330 222-530 222-163 0-321-55-451-153-81-60-152-129-224-199-17-17-35-33-52-50l-8820-8436-8911 8521c-177 170-389 321-644 321s-453-148-612-331l-139-159v-536l143-160c14-16 29-33 43-49 79-91 158-181 245-264 2806-2687 5614-5373 8421-8059l1014-970c18-17 36-34 55-52l397-373 384 384zM17254 2295h-1439c-302 0-604 0-906-1-466-2-828-286-833-767-2-206 68-403 214-551 162-163 385-234 611-235 484 0 969-1 1453-1l2465 1v1278c0 849 1 1698-1 2547-1 135-8 267-52 397-111 326-385 518-728 519-344 1-617-190-730-516-44-129-52-262-52-398-2-600-2-1200-2-1800v-473z"
        className="fil0 "
      />
    </g>
  </svg>
)
export default SvgComponent
